export default __webpack_public_path__ + "static/media/document.0aacd57a.svg";